<template>
  <KTPortlet title="Техника">
    <div slot="toolbar">
      <v-btn color="primary" type="button" @click="newVehicle">Добавить</v-btn>
    </div>
    <div slot="body">
      <vehicle-dialog ref="dialog" @submitted="fetchData" />
      <v-data-table :headers="fields" :items="vehicles" :items-per-page="15">
        <template v-slot:item.available="{ item }">
          <v-switch v-model="item.available" v-if="item.confirmed" @change="switchAvailable(item)" />
          <template v-else>
            <span class="badge badge-warning badge-inline">На модерации</span>
          </template>
        </template>

        <template v-slot:item.photo_url="{ item }">
          <b-img :src="item.photo.url" fluid v-if="item.photo.url" style="max-width: 100px;"></b-img>
        </template>

        <template v-slot:item.prices="{ item }">
          <div v-if="item.min_price > 0">Мин. цена: {{item.min_price}}</div>
          <div
            v-for="price in item.prices"
            :key="price.id"
          >За {{price.measure_unit.name.toLowerCase()}}: {{price.value}}</div>
        </template>

        <template v-slot:item.edit="{ item }">
          <v-btn small icon @click="() => { editVehicle(item) }">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.remove="{ item }">
          <v-btn small color="error" icon @click="() => { removeVehicle(item) }">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </div>
  </KTPortlet>
</template>

<script>
import KTPortlet from "@/view/content/Card.vue";
import VehicleDialog from "@/view/pages/vehicles/VehicleDialog.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "vehicles",
  metaInfo: {
    title: "Техника"
  },
  components: { KTPortlet, VehicleDialog },
  data() {
    return {
      loading: false,
      vehicles: [],
      fields: [
        {
          value: "photo_url",
          text: "Фото"
        },
        {
          value: "name",
          text: "Наименование"
        },
        {
          value: "address",
          text: "Адрес"
        },
        {
          value: "vehicle_type.name",
          text: "Тип"
        },
        {
          value: "prices",
          text: "Цены"
        },
        {
          value: "available",
          text: "Доступна"
        },
        {
          value: "edit",
          text: ""
        },
        {
          value: "remove",
          text: ""
        }
      ]
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Техника" }]);

    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$api["contractor/vehicles"]
        .select()
        .then(response => {
          this.vehicles = response.data.items;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    newVehicle() {
      this.$refs.dialog.open();
    },
    editVehicle(item) {
      this.$refs.dialog.open(item);
    },
    switchAvailable(item) {
      this.$api["contractor/vehicles"]
        .switchAvailable(item.id)
        .then(() => {
          this.$toast.success("Операция выполнена.");
        })
        .catch(error => {
          item.available = !item.available;

          this.$toast.error(error.response.data.errors.base.join(", "), {
            icon: "fa-exclamation-circle"
          });
        });
    },
    async removeVehicle(item) {
      const res = await this.$confirm('Вы действительно хотите удалить технику?', { title: 'Предупреждение', buttonTrueText: 'Да, удалить',
  buttonFalseText: 'Нет', icon: 'fa-exclamation-circle' })
      if (res) {
        this.$api["contractor/vehicles"]
          .delete(item.id)
          .then(() => {
            this.$toast.success("Операция выполнена.");
            this.fetchData();
          })
          .catch(error => {
            this.$toast.error(error.response.data.errors.base.join(", "), {
              icon: "fa-exclamation-circle"
            });
          });
        }
    }
  }
};
</script>
